<template>
  <div class="contenedor-reproductor">
    <div class="reproductor">
      <div class="controles">
        <button class="btn play" @click="toggle_play">
          <!--{{reproductor_is_play ? 'pausa' : 'play' }} -->
          <img v-if="!reproductor_is_play" src="@/assets/img/play.svg" alt="">
                <img v-if="reproductor_is_play" src="@/assets/img/pause.svg" alt="">
        </button>
      </div>
      <div class="historico">
        <output for="slider-reproductor"
        class="tooltip-reproductor"
        :style="{ left :`calc(${(valor_actual/(arrange_fechas.length-1))*100}% + ${((valor_actual/(arrange_fechas.length-1)*2)-1)*-11}px`}"
        >
          <span>
            {{formatearFechaFull(arrange_fechas[valor_actual].toLocaleDateString())}}
          </span>
        </output>
        <input class="slider-reproductor"
        type="range"
        min="0"
        :max="arrange_fechas.length - 1"
        step="1"
        @change="cambioSlider"
        v-model="valor_actual"
        >
        <div class="fecha">
          <div class="item first-date">{{formatearFecha(fecha_min.toLocaleDateString())}}</div>
          <div class="item last-date">{{formatearFecha(fecha_max.toLocaleDateString())}}</div>
        </div>
      </div>
    </div>
    <p class="nota"></p>
  </div>
</template>

<script>
// import Play from "@/assets/img/play.svg"
//import * as d3 from 'd3';
var lista_meses = [
	"Enero",
	"Febrero",
	"Marzo",
	"Abril",
	"Mayo",
	"Junio",
	"Julio",
	"Agosto",
	"Septiembre",
	"Octubre",
	"Noviembre",
	"Diciembre",
]
var lista_meses_min = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
]
var lista_meses_abr = [
	"ene",
	"feb",
	"mar",
	"abr",
	"may",
	"jun",
	"jul",
	"ago",
	"sep",
	"oct",
	"nov",
	"dic",
]
export default {
  name: "ControlReproductor",
  props: {
    fecha_max: Date,
    fecha_min: Date,
    arrange_fechas: Array
  },
  data() {
    return {
      valor_actual:0,
      current_frame:0,
      periodo_dias_frame:14,
      delay: 500,
      reproductor_is_play: false,
      repeat: true
    };
  },
  watch: {
    arrange_fechas(){
      this.valor_actual =this.arrange_fechas.length -1;

      this.reproductor_is_play = false

      this.$store.commit("cambiarFechaClusterSlider", this.arrange_fechas[event.target.value]);
      this.pausar()
    },
    reproductor_is_play: function (newValue){
      if(newValue){
        this.reproducir()
      }else{
        this.pausar()
      }
    }
  },
  methods: {
    reproducir(){
      this.pasos = setInterval(()=>{
          const new_step = (this.valor_actual + 1) < this.arrange_fechas.length ? this.valor_actual+1 : ( this.repeat ? 0 : -1 )
          if(new_step>-1){
              this.valor_actual = new_step
          }else{
              this.pausar()
          }
          this.$store.commit("cambiarFechaClusterSlider", this.arrange_fechas[this.valor_actual]);


      },this.delay)
    },
    pausar(){
      window.clearInterval(this.pasos)
    },
    cambioSlider: function(event){
      this.valor_actual = event.target.value;
      this.reproductor_is_play = false

      this.$store.commit("cambiarFechaClusterSlider", this.arrange_fechas[event.target.value]);
      this.pausar()
    },
    toggle_play: function(){
      this.reproductor_is_play = !this.reproductor_is_play
    },
    formatearFecha(fech){
            let txt = fech.split("/")
            return `${txt[0]}/${lista_meses_abr[parseInt(txt[1])-1]}/${txt[2]}`
        },
    formatearFechaFull(fech){
            let txt = fech.split("/")
            return `${txt[0]}/${lista_meses_min[parseInt(txt[1])-1]}/${txt[2]}`
        }
    


  },
  mounted: function(){
    this.valor_actual =this.arrange_fechas.length -1
    
  },
  
}



</script>

<style lang="scss">
$padding: $gap * .5;

.contenedor-reproductor {
  padding: $padding;
  .nota {
    margin: 5px 0 -5px;
    font-size: map-get($fuente, "size-notas");
  }
}
.reproductor {
  display: flex;
  .controles {
    padding: 0 $gap*.5 0 0;
  }
  .historico {
    flex: 1;
    position: relative;
    padding: $gap*.35 0 0;
    .fecha {
      display: flex;
      justify-content: space-between;
      padding: 5px 0 0 5px;
      font-size: 10px;
    }
  }
}

.btn.play {
  min-width: 40px;
  min-height: 40px;
  background-color: #fff;
  box-shadow: 1px 1px 5px 2px lightgray;
  margin: 0;
  b{
    color: black;
  }
}

.tooltip-reproductor {
  background: white;
  color: black;
  padding: 4px ;
  position: absolute;
  border-radius: 4px;
  white-space: nowrap;
  //left: 50%;
  top: 5px;
  transform: translateX(-50%) translateY(-100%);
  min-width: 120px;
  box-shadow: 0 2px 4px rgba(0,0,0,.3);
  text-align: center;
  font-size: map-get($fuente, "size-notas");
}

.tooltip-reproductor::after {
  content: "";
  position: absolute;
  display: block;
  left: 50%;
  transform: translateX(-50%);
  border-color: #fff transparent transparent;
  border-width: 12px 10px 0 10px;
  border-style: solid solid none solid;
}
.tooltip-reproductor::before {
  content: "";
  position: absolute;
  left: calc(50% - 1px);
  display: block;
  transform: translateX(-50%);
  border-color: rgb(197, 196, 196) transparent transparent;
  border-width: 9px 8px 0 8px;
  border-style: solid solid none solid;
  top: 25px;
}

input[type=range].slider-reproductor {
  width: 100%;
  margin: 0;
  background-color: transparent;
  -webkit-appearance: none;
  padding: 0;
  border: none;
  box-shadow: none;

}
input[type=range].slider-reproductor:hover {
  border: none;
  box-shadow: none;
}

input[type=range].slider-reproductor:focus {
  outline: none;
  box-shadow: none;
}
input[type=range].slider-reproductor::-webkit-slider-runnable-track {
  background: #4468f3;
  border: 0;
  border-radius: 2.9px;
  width: 100%;
  height: 8.4px;
  cursor: pointer;
}
input[type=range].slider-reproductor::-webkit-slider-thumb {
  margin-top: -6.8px;
  width: 22px;
  height: 22px;
  background: #ffffff;
  border: 0.1px solid #000000;
  border-radius: 11px;
  cursor: pointer;
  -webkit-appearance: none;
}
input[type=range].slider-reproductor:focus::-webkit-slider-runnable-track {
  background: #5274f4;
}

input[type=range].slider-reproductor::-moz-range-progress {
  background-color: #4468f3;
  border-radius: 2.9px;
  height: 8.4px;
}
input[type=range].slider-reproductor::-moz-range-track {
  background: lightgray;
  border: 0;
  border-radius: 2.9px;
  width: 100%;
  height: 8.4px;
  cursor: pointer;
}
input[type=range].slider-reproductor::-moz-range-thumb {
  width: 22px;
  height: 22px;
  background: #ffffff;
  border: 0.1px solid #000000;
  border-radius: 11px;
  cursor: pointer;
}
input[type=range].slider-reproductor::-ms-track {
  background: transparent;
  border-color: transparent;
  border-width: 7.8px 0;
  color: transparent;
  width: 100%;
  height: 8.4px;
  cursor: pointer;
}
input[type=range].slider-reproductor::-ms-fill-lower {
  background: #365cf2;
  border: 0;
  border-radius: 5.8px;
}
input[type=range].slider-reproductor::-ms-fill-upper {
  background: #4468f3;
  border-radius: 2.9px;
  border: 0;
  border-radius: 5.8px;
}
input[type=range].slider-reproductor::-ms-thumb {
  width: 22px;
  height: 22px;
  background: #ffffff;
  border: 0.1px solid #000000;
  border-radius: 11px;
  cursor: pointer;
  margin-top: 0px;
}
input[type=range].slider-reproductor:focus::-ms-fill-lower {
  background: #4468f3;
  border-radius: 2.9px;
}
input[type=range].slider-reproductor:focus::-ms-fill-upper {
  background: #5274f4;
}
/*TODO: Use one of the selectors from https://stackoverflow.com/a/20541859/7077589 and figure out
how to remove the virtical space around the range input in IE*/
@supports (-ms-ime-align:auto) {
  /* Pre-Chromium Edge only styles, selector taken from hhttps://stackoverflow.com/a/32202953/7077589 */
  input[type=range].slider-reproductor {
    margin: 0;
    /*Edge starts the margin from the thumb, not the track as other browsers do*/
  }
}
</style>
